<template>
    <div>
        <navbar></navbar>
        
        <div class="container">
            <p class="__portpnew">Bringing Lagos Data to Life — How Findworka Built the EKO360 Interactive Dashboard for Data Science Nigeria</p>
            <p class="__portp2new">Findworka transformed raw, complex public-sector datasets into EKO360, an interactive, mobile-ready dashboard that delivers real-time insights for policymakers, researchers, and citizens..</p>
            <p class="__meetdname"><span class="__namp">Client Name:</span> Data Science Nigeria (DSN)</p>
            <p class="__meetdname"><span class="__namp">Product:</span> EKO360 — Interactive Data-Visualization Dashboard</p>
            <p class="__meetdname"><span class="__namp">Timeline:</span> Q1 2024 – Q2 2024</p>
            <p class="__meetdname"><span class="__namp">Scope:</span> Web-based dashboard for dynamic analysis of Lagos State’s education, health, and economic data.</p>
            <p class="__meetdname"><i>A forward-thinking AI non-profit wanted to unlock the value buried in Lagos State spreadsheets. Together we built a tool that now guides evidence-based decisions across government and civil society.</i></p>
            
            <p class="__headin">The Challenge</p>
            <p class="__meetdname"><span class="__namp">Making Big Data Meaningful for Lagos State</span></p>
            <p class="__meetdname">Lagos is a data goldmine — but without a smart tool to decode it, all that value remained buried in spreadsheets. DSN needed a robust, user-friendly dashboard that could:</p>
            <ul class="__portp2new">
                <li>Visualize cross-sector insights across education, health, and economic affairs</li>
                <li>Support drill-down exploration from state-wide to individual Local Government Area (LGA) levels</li>
                <li>Present patterns and trends in an intuitive, interactive format</li>
                <li>Be scalable, responsive, and easy to update</li>
            </ul>

            <p class="__headin">The Solution</p>
            <p class="__meetdname"><span class="__namp">EKO360 — Built for Insight, Designed for Impact</span></p>
            <p class="__meetdname">We approached the project as both engineers and designers of experience. Our first step was immersing ourselves in the data — understanding what mattered, what didn’t, and how users would want to engage with the dashboard. Here’s what we built:</p>
            <ul class="__portp2new">
                <li><b class="__namp">Smart Data Layering – </b>Toggle between categories from primary-school infrastructure to health and economic indicators.</li>
                <li><b class="__namp">Interactive Map Navigation – </b>Click any LGA on the Lagos map to view detailed regional stats.</li>
                <li><b class="__namp">Dynamic Visualizations – </b>Clean, customizable charts and graphs that make trend tracking a breeze.</li>
                <li><b class="__namp">Responsive & Accessible – </b>Mobile-first so researchers on the move and policymakers in meetings can explore insights anywhere.</li>
            </ul>
            <img src="../assets/img/ekolanding.png" class="__climgr"/>

            <p class="__headin">Key Features</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/rtlist.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Real-Time Data Layering</span></p>
                        <p class="__meetdname">Toggle sector dashboards instantly</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftmap.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Clickable Lagos Map</span></p>
                        <p class="__meetdname">Drill into any LGA for hyper-local stats</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__cards">
                        <img src="../assets/img/ftmob.png" class="__futimg"/>
                        <p class="__meetdname"><span class="__namp">Mobile-First Charts</span></p>
                        <p class="__meetdname">Fast, responsive visuals on any device</p>
                    </div>
                </div>
            </div>

            <p class="__headin">Client Testimonial</p>
            <p class="__meetdname">“This dashboard makes our data not just understandable, but powerful. It gives Lagos a data-driven voice.” <span class="__namp"><i>— DSN Analyst</i></span></p>

            <p class="__headin">Results / Impact Tiles</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Adopted by NGOs & analysts</span></p>
                        <p class="__meetdname">Guides educational & infrastructure planning</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Adopted by NGOs & analysts</span></p>
                        <p class="__meetdname">Source-of-truth for Lagos data storytelling</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Sparked evidence-based investment talks</span></p>
                        <p class="__meetdname">Opens doors for public-sector decision making</p>
                    </div>
                </div>
            </div><br>
            <p class="__meetdname">At Findworka, we believe tech must translate into transformation. With EKO360, we didn’t just build a dashboard — we built a bridge between complex data and informed public impact. Because when data is well presented, governance becomes smarter, citizens become more informed, and cities like Lagos unlock their true potential.</p>

            

            <div class="text-center">
                <p class="__hvsip">Have an idea to ship? Let’s build it—fast.</p>
                <p class="__meetdname">Tell us about your product vision and get a scoped build plan within 48 hours.</p>
                <router-link to="/build" class="btn __viewsite">Get Started Here </router-link>
            </div>
            <div class="__whitespace"></div>
        </div>
        <!-- <div class="__stbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-5">
                        <p class="__wwd">Start a project with us</p>
                        <p class="__fbuild">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                        <router-link to="/build" class="btn __startp">Lets do this</router-link>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7"></div>
                </div>
            </div>
        </div> -->
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/eko.vue